import { Component, Input } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { FlatpickrModule } from 'angularx-flatpickr';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, FlatpickrModule, IconModule, MaterialModule],
  selector: 'app-birthday-card',
  templateUrl: './birthday-card.component.html',
  styleUrl: './birthday-card.component.scss'
})
export class BirthdayCardComponent {
  @Input() userName:string='';
  @Input() userPost:string='';
  @Input() discription: string='';
  @Input() imageUrl: string = '';
  @Input() datePost: string = '';
}
